module.exports = __webpack_public_path__ + "img/keder_weiss-transluzent.bc5dedbc.jpg";